var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"table-icon tooltip",attrs:{"data-tooltip":"Play All"},on:{"click":_vm.playPitchGroup}},[_c('IconPlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }